.questionnaire-history-table{background:transparent;margin-bottom:1rem}.history-state{min-height:10rem;display:flex;align-items:center;justify-content:center;text-align:center;background:#fff;padding:1.5rem}.history-error{color:#cf1322}
/*# sourceMappingURL=questionnaire-history-table.component-TQR2GFI3.css.map */
